import axios from 'axios';

export interface Parameter {
  id: number;
  parameterKey: string;
  parameterValue: string | null;
  description: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateParameterPayload {
  parameterKey: string;
  parameterValue: string | null;
  description: string | null;
}

export interface UpdateParameterPayload {
  parameterValue: string | null;
  description: string | null;
}

export const parametersApi = {
  getAll: async (): Promise<Parameter[]> => {
    const response = await axios.get<Parameter[]>('/parameters');
    return response.data;
  },

  getById: async (id: number): Promise<Parameter> => {
    const response = await axios.get<Parameter>(`/parameters/${id}`);
    return response.data;
  },

  create: async (data: CreateParameterPayload): Promise<Parameter> => {
    const response = await axios.post<Parameter>('/parameters', data);
    return response.data;
  },

  update: async (id: number, data: UpdateParameterPayload): Promise<Parameter> => {
    const response = await axios.put<Parameter>(`/parameters/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axios.delete(`/parameters/${id}`);
  }
};
